import React from 'react'

import { Descriptions } from 'antd'
import { useLocation } from 'react-router-dom'

import { ClusterCluster } from '@clinic/client'
import { useCurOrg } from '~/hooks/state'
import { ReportBasic } from '~/pages/reports/shared/types'
import { ReportPVType, useReportPV } from '~/pages/reports/shared/utils/pv'
import { formatDateTime } from '~/utils/date-time'

export const BasicInfo: React.FC<{
  reportType: ReportPVType
  report?: ReportBasic
  clusterData?: ClusterCluster
}> = ({ report, clusterData, reportType }) => {
  const location = useLocation()
  const { curOrg } = useCurOrg()
  const { pv } = useReportPV(reportType, location.pathname)

  return (
    <Descriptions column={2}>
      <Descriptions.Item label='Tenant'>{curOrg?.name}</Descriptions.Item>
      <Descriptions.Item label='Cluster'>{clusterData?.name}</Descriptions.Item>
      <Descriptions.Item label='Creator'>{report?.creator}</Descriptions.Item>
      <Descriptions.Item label='Created At'>
        {formatDateTime(report?.createdAt!)}
      </Descriptions.Item>
      <Descriptions.Item label='Time Range'>
        {!!report?.args &&
          `${formatDateTime(report?.args.begin_ts)} - ${formatDateTime(
            report?.args.end_ts
          )}`}
      </Descriptions.Item>
      <Descriptions.Item label='View Count'>{pv}</Descriptions.Item>
    </Descriptions>
  )
}
